import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const DesktopFootwear = dynamic(() => import('../../components/retail/footwear/DesktopFootwear'), {
  loading: () => <Loading />,

});

const MobileFootwear = dynamic(() => import('../../components/retail/footwear/MobileFootwear'), {
  loading: () => <Loading />,

});

const footwear = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Best Footwear POS Billing Software India | Shoe Billing System</title>
        <link rel="canonical" href="https://queuebuster.co/retail/footwear-pos-billing-software" />
        <link href="https://queuebuster.co/retail/footwear-pos-billing-software" hrefLang="en-us" />
        <meta name="description" content="India #1 footwear POS billing software that maintain your billing/invoices, shoes inventory and more. Download QueueBuster footwear POS solutions for Free!" />
        <meta property="og:title" content="Best Footwear POS Billing Software India | Shoe Billing System" />
        <meta property="og:description" content="India #1 footwear POS billing software that maintain your billing/invoices, shoes inventory and more. Download QueueBuster footwear POS solutions for Free!" />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/assets/outlet-og-img/footwear.jpg" />
        <meta property="og:url" content="https://queuebuster.co/retail/footwear-pos-billing-software" />

      </Head>
         <SchemaTags page="footwear-pos-billing-software" />
      {
        mobileView ? <MobileFootwear /> : <DesktopFootwear />
      }
    </>
  )
}

export default footwear